//@ts-check
import React from "react";
import "./buttonHL.css";

/**
 * @typedef {object} PropsCustom
 * @property {string} [nameBtn] Text inside the button
 * @property {boolean} [primary] Adjust the styles for primary button
 * @property {boolean} [disabled] State that enables or disables the button
 * @property {import('react').MouseEventHandler<HTMLButtonElement>} [onClickBtn] Event when button is clicked
*/

/**
 * @typedef {Omit<import('react').ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & PropsCustom} Props
 */

/**
 * @param {Props} props
 */
const ButtonHLPure = (props) => {
  const {
    nameBtn,
    primary,
    onClickBtn,
    disabled
  } = props;

  return (
    <button
      {...props}
      className={
        primary === true ? "buttonHLPure-primary" : "buttonHLPure-secondary"
      }
      onClick={onClickBtn}
      disabled={disabled}
    >
      {nameBtn}
    </button>
  );
};

export { ButtonHLPure as default };